import {
    Stack, Container,
    Box,
} from '@mui/material'
import { HolidayVillage } from '@mui/icons-material';
import { useEffect, useState, useContext } from 'react'
import { ProfileContext } from '../../contexts/ProfileContext';
import { ModalError } from '../../ui-component'
import * as api from '../../api/Loan'
import { useNavigate, useLocation } from 'react-router-dom';
import { ChipRoomInfo } from '../../ui-component/ChipRoomInfo';
import { LoanDetailComponent } from './LoanDetailComponent';
export const Loan = () => {

    const [profile, setProfile] = useState(null)
    const [houseInfo, setHouseInfo] = useState(null)
    const [listLoan, setListLoan] = useState([])
    const [modalError, setModalError] = useState(false);
    const [error, setError] = useState(null);
    const context = useContext(ProfileContext)
    const navigate = useNavigate()
    const location = useLocation()

    const loadLoanList = async () => {
        let res = await api.getLoanListAll({
            "line_id": profile?.line_id,
            "language": profile?.language,
            "product_type": houseInfo?.product_type,
            "project_id": houseInfo?.project_id,
            "unit_number": houseInfo?.unit_number
        })
        if (res?.status === 200) {
            setListLoan(res.data)
            return
        }
        setError(res)
        setModalError(true)
        return
    }

    useEffect(() => {
        if (profile !== null) {
            loadLoanList()
        }
    }, [profile, houseInfo]);

    useEffect(() => {
        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }

        if (context?.state.houseInfo) {
            setHouseInfo(context?.state?.houseInfo)
        }
    }, [context])

    return (
        <>
            <Box sx={{ height: "100vh" }}>

                <Container sx={{ minHeight: "100%", paddingTop: 2, paddingBottom: 5 }} >

                    <Stack direction={"row"} alignItems="center" justifyContent={"flex-start"}>
                        <ChipRoomInfo
                            houseInfo={houseInfo}
                            icon={<HolidayVillage />}
                            lang={profile?.language}
                        />
                    </Stack>
                    <Stack mt={1} spacing={2}>
                        {/* {
                            listLoan?.map(element => <Card variant="outlined"
                                sx={{ borderRadius: "10px", display: "flex" }}
                                onClick={() => navigate(`/loan/result${location.search}`, {
                                    state: element
                                })}
                            >
                                <Stack direction={"row"} sx={{ padding: 3, width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box>
                                        <Typography variant="h6" >
                                            {element.bank_name}
                                        </Typography>
                                        <Stack direction="row" spacing={1} alignItems={"center"}>
                                            <Typography variant="caption">{dict.Loan_Status_TXT[profile?.language]}: </Typography>
                                            <Chip style={{ color: typeLoan[element.status]?.color, fontWeight: "bold" }} label={element.status_name} >
                                            </Chip>
                                        </Stack>
                                        <Stack direction="row" spacing={1} alignItems={"flex-start"} mt={1}>
                                            <Typography variant="caption" color={"CaptionText"}>
                                                {dict.Date_Status_TXT[profile?.language]}: {element.request_date}
                                            </Typography>
                                        </Stack>
                                    </Box>
                                    <Box>
                                        <ArrowForwardIos sx={{ fontSize: 16 }} color={"action"} />
                                    </Box>
                                </Stack>
                            </Card>
                            )
                        } */}
                    </Stack>
                </Container>
            </Box >
            <ModalError
                onClose={() => setModalError(false)}
                open={modalError}
                error={error}
            />
        </>
    )

}